import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { initialAccountState } from "./state"
import { AccountData } from "../../services/account.service"

export const accountSlice = createSlice({
  name: "account",
  initialState: initialAccountState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setAccountData: (state, action: PayloadAction<AccountData>) => {
      state.user = action.payload.user
      state.configurations = action.payload.configurations
      state.isAuthenticated = true
      state.error = null
      state.isLoading = false
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isLoading = false
      state.isAuthenticated = false
    },
    clearAccount: (state) => {
      state.user = null
      state.configurations = []
      state.isAuthenticated = false
      state.error = null
      state.isLoading = false
    },
    setConfigurations: (state, action: PayloadAction<any[]>) => {
      state.configurations = action.payload
    },
  },
})

export const {
  setLoading,
  setAccountData,
  setError,
  clearAccount,
  setConfigurations,
} = accountSlice.actions
